import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { EColors } from "libs/style/w24_styling"
import React from "react"
import styled from "styled-components/macro"

interface Props {
  iconSize: string
  icon: IconDefinition
  color: EColors
  onClick?: () => void
  className?: string
}

export const FontIcon = (props: Props): JSX.Element => {
  return (
    <S_FontIcon
      size={props.iconSize}
      color={props.color}
      onClick={props.onClick}
      className={props.className}
    >
      <FontAwesomeIcon icon={props.icon} />
    </S_FontIcon>
  )
}

export const S_FontIcon = styled.div`
  display: flex;
  align-items: center;
  height: fit-content;
  > svg {
    font-size: ${props => props.size};
    color: ${props => props.color};
  }
`
